import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Page, Control, Divider,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './Departments.module.sass';

function DepartmentCameraForm({
  camsOptions = [],
  onSubmit = () => {},
}) {
  const { t } = useTranslation();

  const formMethods = useForm();

  const {
    control,
    handleSubmit,
    formState: {
      errors,
    } } = formMethods;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Page
        className={st.FormWidth}
        title={t('departments:camera.form.title')}
      >
        <Divider />

        <Control.Select
          control={control}
          errors={errors}
          id="camera"
          label={t('departments:camera.form.label')}
          name="camera"
          options={camsOptions}
          rules={{ required: validate.required() }}
        />
        <Divider small />

        <Control.Button fullWidth type="submit">
          {t('form.submit')}
        </Control.Button>
      </Page>
    </form>
  );
}

export default DepartmentCameraForm;
